






















import mixin from './cardmixin.vue'
import {convertSeconds} from '@/utils/index'
import Vue from 'vue'
import { StatusRecordCardServiceProxy } from '@/service-proxies/app-v2/mdc.service-proxies'
import { WorkStationWcsSettingServiceProxy } from '@/service-proxies/app-v2/workStation.service-proxies'
const wswssp = new WorkStationWcsSettingServiceProxy()
const srcsp = new StatusRecordCardServiceProxy()

export default Vue.extend({
  name: 'device-status-table',
  mixins: [mixin],
  data() {
    return {
      dict: {
        // 报警故障: "#FA554C",
        // 手动模式等待: "#F8BB09",
        // 自动模式等待: "#FFEC00",
        // 其他模式等待: "#FEFF98",
        // 手动模式运行: "#2A9F0C",
        // 自动模式运行: "#7ED321",
        // 其他模式运行: "#9CFF30",
        // 离线: "#696969",
        // 网络断线: "#C0C0C0",
      },
      data: []
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('page_card_workstation_code'),
          dataIndex: 'workStationCode'
        },
        {
          title: this.$t('page_card_workstation_name'),
          dataIndex: 'workStationName'
        },
        {
          title: this.$t('page_card_current_status'),
          dataIndex: 'currentStatus',
          width: 120,
          ellipsis: true,
          scopedSlots: { customRender: 'status' }
        },
        {
          title: this.$t('page_card_status_time'),
          dataIndex: 'statusTime',
        },
        {
          title: this.$t('page_card_current_plancode'),
          dataIndex: 'currentPlanCode',
          width: 150,

        },
        {
          title: this.$t('page_card_output_volume'),
          dataIndex: 'outputVolume',
          width: 80
        }
      ]
    }
  },
  mounted() {
    this.getList()
    this.getDict()
  },
  methods: {
    async getList() {
      const data = await srcsp.statusRecordCard()
      this.data = data
      this.data.forEach(res => {
        if (res.statusTime) {
          res.statusTime = convertSeconds(res.statusTime)
        }
      })
      this.checkScrollY('device-status', this.data.length)
    },
    async getDict() {
      let res = await wswssp.getWorkStationWcsSettingList()
      let temp = {}
      res.map((item) => {
        temp[String(item.code)] = item
      })
      this.dict = temp
    }
  }
})
